import RefContainer from "csi/heading/RefContainer";
import declare from "dojo/_base/declare";

const PropertiesViewAffectedItemsRenderer = declare(RefContainer, {

	/**
	 * @override
	 * Display AffectedItems as strings instead of refs when ECPurpose==ImpactAnalysis
	 */
	_toHtmlAnchor(ctx, h, refNode, linkNode): HTMLElement {
		if (ctx.getNode().Purpose == "ECPurpose:ImpactAnalysis") {
			return null;
		} else {
			return this.inherited(arguments) as unknown as HTMLElement;
		}
	},

});

export = PropertiesViewAffectedItemsRenderer;